import React, { Fragment } from 'react'
import { ButtonLink, Loader } from 'stylist'
import { Route, Switch } from 'react-router-dom'
import RouteShow from './show'
import RouteEdit from './edit'
import Feature from 'components/Feature'
import FeatureProvider from 'components/Feature/Provider'
import Header from 'components/Header'

const RouteFeature = ({ match: { url, params, path }, location }) => (
  <FeatureProvider variables={params}>
    <Feature
      render={({ loading, feature }) =>
        loading ? (
          <Loader size="lg" centered />
        ) : (
          <Fragment>
            <ButtonLink marginBottom to="/admin/features" size="sm">
              Back
            </ButtonLink>
            <Header>
              <div>
                <h3>{feature.name}</h3>
              </div>
              <div>
                {!/\/edit\/?$/.test(location.pathname) && (
                  <ButtonLink to={`${url}/edit`}>Edit</ButtonLink>
                )}
              </div>
            </Header>
            <div>
              <Switch>
                <Route path={`${path}/edit`} component={RouteEdit} />
                <Route path={url} component={RouteShow} />
              </Switch>
            </div>
          </Fragment>
        )
      }
    />
  </FeatureProvider>
)

export default RouteFeature



// WEBPACK FOOTER //
// ./src/routes/admin/features/feature.js